import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = {
  title?: string;
  className?: string;
  blue?: boolean;
  size?: Unit;
};

export const Ineligible = ({
  className,
  size = 3,
  title,
  blue = false,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect
        x="23.3137"
        y="12"
        width="16"
        height="16"
        rx="2"
        transform="rotate(135 23.3137 12)"
        fill={blue ? 'var(--c-blue-400)' : 'var(--c-red-400)'}
      />
      <rect
        x="6.34314"
        y="7.75732"
        width="2"
        height="14"
        rx="1"
        transform="rotate(-45 6.34314 7.75732)"
        fill="white"
      />
      <rect
        x="7.75735"
        y="17.6567"
        width="2"
        height="14"
        rx="1"
        transform="rotate(-135 7.75735 17.6567)"
        fill="white"
      />
    </svg>
  );
};
